module.exports = __webpack_public_path__ + "img/yyzxpos1.038a7c9.png";